import { fetchWrapper } from "_helpers";

const baseUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_CONTEXT_PATH}/jobs`;

export const jobService = {
  getAll,
  getSuggestion,
  search,
  getById,
  create,
  update,
  delete: _delete,
  updateJobTask,
  getOutcome,
};

function getAll() {
  return fetchWrapper.get(baseUrl);
}

function search(params) {
  return fetchWrapper.get(`${baseUrl}${params}`);
}

function getSuggestion() {
  return fetchWrapper.get(`${baseUrl}/suggestion`);
}

function getById(id) {
  return fetchWrapper.get(`${baseUrl}/${id}`);
}

function create(params) {
  return fetchWrapper.post(baseUrl, params);
}

function update(id, params) {
  return fetchWrapper.put(`${baseUrl}/${id}`, params);
}

function _delete(id) {
  return fetchWrapper.delete(`${baseUrl}/${id}`);
}

function updateJobTask(taskId,JobId, params) {
    return fetchWrapper.put(`${baseUrl}/jobTask/${JobId}/${taskId}`, params);
}

function getOutcome(id) {
  return fetchWrapper.get(`${baseUrl}/${id}/products`);
}
